<template>
	<div id="share">
		<!-- <div class="titleName">{{title}}</div>
		<div class="msgTitle">
			<div style="margin-right: 10px">{{modifyTime}}</div>
			<div>中建教育</div>
		</div> -->
		<div id="content" v-html="html"></div>
	</div>
</template>

<script>
	export default{
		data(){
		  return {
			title: '', // 标题
			html: '', // 文本
			modifyTime: '', // 时间
		  }
		},
		created() {
			this.detail()
		},
		metaInfo () {
			return {
				title: this.title
			}
		},
		methods:{
			async detail(){
				let result = await this.$API.getNotifiNoticeDetail(this.$route.params.id)
				 if(result.msg == '请求成功'){
				   this.title = result.data.title
				   this.modifyTime = result.data.modifyTime
				   this.html = result.data.content
				 }else{
					 Toast('数据获取失败')
				 }
			},
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	.titleName
		text-align center
		margin-top 10px
	.msgTitle
		display flex;
		justify-content center;
		align-items center;
		margin-top 10px
	#content
		margin 15px
        p{
            font-size: 14px
        }
</style>
